export default {
  en: {
    searchTexts: 'Search Texts',
    collectionDescription: 'Comma separated list of collection names to search',
    characterSequenceDescription: 'Transliteration Search',
    collectionNames: 'Collection Names',
    characterSequences: 'Character Sequences',
    searchBtnText: 'Search',
    noData: 'No data available',
    loadingText: 'Loading items...',
    matchingTexts: 'Matching texts',
    textTitle:
      'Title of texts to search (can be a substring of the actual title, e.g. CCT)',
  },
  tr: {
    searchTexts: 'Metinlerde ara',
    collectionDescription:
      'Aramak için virgülle ayrılmış koleksiyon adları listesi',
    characterSequenceDescription:
      'Kaba karakter dizisi araması (sözcük sınırlarını ve karakter türünü yok sayar)',
    collectionNames: 'Koleksiyon İsimleri',
    characterSequences: 'Karakter Dizileri',
    searchBtnText: 'Arama',
    noData: 'Veri yok',
    loadingText: 'Öğeler yükleniyor...',
    matchingTexts: 'Eşleşen metinler',
    textTitle:
      'Aranacak metinlerin başlığı (asıl başlığın bir alt dizesi olabilir, örn. CCT)',
  },
};
